

const getTime = (calculatedDate) => {
const time = new Date()
const currentDate = calculatedDate || time

const hours = currentDate.getHours();
const minutes = currentDate.getMinutes();

const fixedHours = hours < 10 ? `0${hours}` : hours
const fixedMinutes = (minutes + 1) < 10 ?  `0${minutes + 1}`: minutes + 1

return `${fixedHours}:${fixedMinutes}`
}

export {getTime}